import { Link } from "react-router-dom";
import type { CategoryTreeNode } from "@/lib/api-client";

export interface CategoryQuickLinksProps {
  /** Rayons de niveau 1 réels, tels que renvoyés par `getCategoryTree()`. */
  categories: CategoryTreeNode[];
}

/**
 * Porté à l'identique depuis apps/web/components/home/CategoryQuickLinks.tsx.
 * Seul changement : `next/link` → `Link` de react-router-dom, `next/image`
 * (jamais utilisé dans l'original, déjà un `<img>` simple) inchangé.
 */
const TILE_TINTS = ["#14213D", "#B8964A", "#24365E", "#8A7346", "#1B2A4A", "#3A4A6B", "#6B5B3A", "#C9A227"];

export function CategoryQuickLinks({ categories }: CategoryQuickLinksProps) {
  const visible = categories.filter((category) => category.isVisible);
  if (visible.length === 0) return null;

  return (
    <section className="container-vvs py-8 lg:py-10">
      <h2 className="font-display text-xl font-semibold text-navy">Acheter par rayon</h2>
      <ul className="mt-5 flex snap-x snap-mandatory gap-5 overflow-x-auto pb-2 lg:grid lg:grid-cols-4 lg:gap-6 lg:overflow-visible">
        {visible.map((category, index) => (
          <li key={category.id} className="w-28 flex-shrink-0 snap-start lg:w-auto">
            <Link to={`/catalogue/${category.slug}`} className="group flex flex-col items-center gap-2.5 text-center">
              <span className="rounded-full bg-gradient-to-tr from-navy via-gold to-goldl p-[3px] shadow-sm transition-transform duration-200 group-hover:scale-105">
                <span className="block rounded-full bg-cream p-[3px]">
                  {category.imageUrl ? (
                    <img
                      src={category.imageUrl}
                      alt=""
                      loading="lazy"
                      className="h-24 w-24 rounded-full object-cover sm:h-28 sm:w-28"
                    />
                  ) : (
                    <span
                      aria-hidden="true"
                      style={{ backgroundColor: TILE_TINTS[index % TILE_TINTS.length] }}
                      className="flex h-24 w-24 items-center justify-center rounded-full font-display text-2xl font-semibold text-cream sm:h-28 sm:w-28"
                    >
                      {category.name.charAt(0)}
                    </span>
                  )}
                </span>
              </span>
              <span className="font-body text-[11px] font-semibold uppercase tracking-wide text-ink">
                {category.name}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
